// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import type { GroupedObjectParameters } from '../types'
import VkGroupsSelect from '../VkGroupsSelect'
import LabeledWrapper from './LabeledWrapper'
import HintWrapper from '../controls/HintWrapper'
import Button from '../controls/PrimaryButton'
import AddParametersGroupBlock from './AddParametersGroupBlock'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
`

type Props = {
  selectClassName: string,
  buttonClassName: string,
  blockInputName: string,
  title: string,
  hint: string,
  groups: Array<GroupedObjectParameters>,
  loadedGroups: Array<Object>,
  errors: Array<string>,
  allowAdding: boolean,
  onChange: (Array<GroupedObjectParameters>) => void,
  onGroupAdd: () => void,
  onGroupRemove: (Array<GroupedObjectParameters>) => void,
  onLoad: (Array<Object>) => void
}

const t = {
  add: 'Добавить группу'
}

export default class GroupedObjectParametersSelect extends Component<Props> {
  render() {
    const {
      selectClassName,
      buttonClassName,
      blockInputName,
      groups,
      loadedGroups,
      errors,
      allowAdding,
      onChange,
      onGroupAdd,
      onGroupRemove,
      onLoad
    } = this.props
    return (
      <LabeledWrapper label={this.renderLabelBlock()} errors={errors} twoLines>
        {_.map(groups, (group, index: number) => {
          return (
            <Wrapper key={index} className={`${selectClassName}_${index}`}>
              <VkGroupsSelect
                values={group.value}
                loadedGroups={loadedGroups}
                onChange={(newGroups) => {
                  const newValue = _.uniqBy(
                    _.concat(group.value, ...newGroups),
                    (vkGroup) => vkGroup.id
                  )
                  const allGroups = _.cloneDeep(this.props.groups)
                  allGroups[index].value = newValue
                  this.props.onChange(allGroups)
                }}
                onLoad={(loaded) => onLoad(loaded)}
              />
              {groups.length > 1 && (
                <AddParametersGroupBlock
                  index={index}
                  groups={groups}
                  currentGroup={group}
                  inputName={`${blockInputName}_${index}`}
                  inputValue={group.name}
                  onChange={(groups) => onChange(groups)}
                  onGroupRemove={(groups) => onGroupRemove(groups)}
                />
              )}
            </Wrapper>
          )
        })}
        {allowAdding && (
          <Wrapper>
            <Button
              className={buttonClassName}
              small
              onClick={() => {
                onChange(_.concat(groups, { value: [], name: '' }))
                onGroupAdd()
              }}
            >
              {t.add}
            </Button>
          </Wrapper>
        )}
      </LabeledWrapper>
    )
  }

  renderLabelBlock() {
    const { title, hint } = this.props
    return <HintWrapper triggerText={title} popupText={hint} alignLeft />
  }
}
